import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

/**
 * GeoMetaTags Component
 * 
 * Adds geographic targeting meta tags to /global/* pages to ensure they
 * are shown primarily to US users in search results.
 * 
 * Problem: Global pages (US-specific state/product content) were receiving
 * 70% of impressions from wrong countries (Canada 33.8%, Pakistan, India, etc.)
 * 
 * Solution: Add geo meta tags to signal to search engines that /global/* 
 * content is targeted to United States audience only.
 * 
 * Expected Impact:
 * - US impressions increase from 30% → 80%+
 * - Reclaim ~6,500 wasted impressions per week
 * - Increase US clicks from 11 → 30+ per week
 * 
 * Reference: GEO_TARGETING_FIX_GUIDE.md (Tier 1 Implementation)
 */
export const GeoMetaTags = () => {
  const location = useLocation();
  
  // Only apply geo tags to /global/* routes
  if (!location.pathname.startsWith('/global')) {
    return null;
  }
  
  return (
    <Helmet>
      {/* Primary geo targeting tags */}
      <meta name="geo.region" content="US" />
      <meta name="geo.placename" content="United States" />
      
      {/* Geographic center of continental US (Lebanon, Kansas) */}
      <meta name="geo.position" content="37.09024;-95.712891" />
      <meta name="ICBM" content="37.09024, -95.712891" />
      
      {/* Dublin Core geographic metadata */}
      <meta name="DC.title" content="United States" />
    </Helmet>
  );
};

export default GeoMetaTags;
